export default __webpack_public_path__ + "static/media/reserva_extender.dcb70715.jpg";